import { Callout } from '../cdl/Callout/Callout';
import { translate } from '../common/helpers/translate.helper';
import { IconInfoCircle } from '../common/icons/cdl/InfoCircle';
import { Box } from '../common/ui/Box';

import { ReimportRequisitionSection } from './components/ReimportRequisitionSection';

export const CloudFleetManagerPageContent = () => {
    return (
        <div>
            <Callout
                heading={translate('integrationsOverview.calloutCloudFleetManager.headline')}
                description={translate('integrationsOverview.calloutCloudFleetManager.description')}
                Icon={IconInfoCircle}
            />
            <Box display="grid" maxWidth="800px" rowGap={40} marginTop={24}>
                <ReimportRequisitionSection />
            </Box>
        </div>
    );
};
